/**
 * Renders children at `document.body`, outside whatever is above them.
 *
 * `position: fixed` is only fixed to the viewport if no ancestor has become a
 * containing block, and a transform is enough to do that — including one left
 * behind by a finished animation. `<main>` carries `.kete-enter`, so a sheet
 * rendered from inside a view centres itself in a register that may be several
 * screens tall and runs off the bottom, with body scroll locked behind it.
 *
 * The sheets that already worked only worked because they happen to be mounted
 * from `App`, above that element. That is not a property worth relying on: it
 * makes "does this overlay work" depend on where its owner sits in the tree.
 */

import type { ReactNode } from 'react'
import { createPortal } from 'react-dom'

export function Portal({ children }: { children: ReactNode }) {
  return createPortal(children, document.body)
}
